module.exports = __webpack_public_path__ + "img/line-dot-left.e8bcbda8.svg";